import { RootState } from '../redux/store';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from '../helpers/common';

export interface IShipping {
  id: number;
  companyId: number;
  code?: string;
  address?: string;
  stateId?: number;
  cityId?: number;
  zipCode?: string;
  orderId?: number;
  clientId?: number;
  phone?: string;
  contact?: string;
  notes?: string;
  deliveryAt?: string;
  isActive: boolean;
  isSelfPickUp?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export const shippingApi = createApi({
  reducerPath: 'shippingApi',
  tagTypes: ['Shipping'],
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: async (headers, { getState }) => {
      const token = (getState() as RootState).user.info.accessToken;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getShippingByClientId: build.query<IShipping | null, { id: number }>({
      transformResponse: (response: { data: IShipping | null }) => response.data,
      query: ({ id }) => ({
        url: `/shipping/client/${id}`,
        method: 'GET',
      }),
      providesTags: ['Shipping'],
    }),
    updateShippingByClientId: build.mutation<
      IShipping,
      { id: number; data: Partial<IShipping> }
    >({
      transformResponse: (response: { data: IShipping }) => response.data,
      query: ({ id, data }) => ({
        url: `/shipping/client/${id}`,
        method: 'PATCH',
        body: data,
      }),
    }),
    getShippingByStockOwnerId: build.query<IShipping | null, { id: number }>({
      transformResponse: (response: { data: IShipping | null }) => response.data,
      query: ({ id }) => ({
        url: `/shipping/stockowner/${id}`,
        method: 'GET',
      }),
      providesTags: ['Shipping'],
    }),
    updateShippingByStockOwnerId: build.mutation<
      IShipping,
      { id: number; data: Partial<IShipping> }
    >({
      transformResponse: (response: { data: IShipping }) => response.data,
      query: ({ id, data }) => ({
        url: `/shipping/stockowner/${id}`,
        method: 'PATCH',
        body: data,
      }),
    }),
  }),
});

export const {
  useGetShippingByClientIdQuery,
  useLazyGetShippingByClientIdQuery,
  useUpdateShippingByClientIdMutation,
  useGetShippingByStockOwnerIdQuery,
  useLazyGetShippingByStockOwnerIdQuery,
  useUpdateShippingByStockOwnerIdMutation,
} = shippingApi;

